module.exports = {"publisher":"Vydavateľ: ","certificate":"Obdržaný certifikát","noData":"Subjekt nie je držiteľom žiadneho certifikátu"}